module.exports = __webpack_public_path__ + "static/media/Cross bite5.38ad66b8.png";